import React from 'react';
import { FileText } from 'lucide-react';
import { LIFECYCLE_STAGES } from '../../data/drhpTrackerData';

export const DrhpLifecycleGuide = () => (
  <section aria-labelledby="drhp-lifecycle-heading" className="bg-white rounded-2xl border border-slate-200/90 shadow-sm p-4 sm:p-5">
    <div className="flex flex-wrap items-start justify-between gap-2">
      <div>
        <p className="text-[10px] font-extrabold uppercase tracking-wider text-[#008080]">Regulatory Framework Guide</p>
        <h2 id="drhp-lifecycle-heading" className="mt-0.5 text-sm sm:text-base font-extrabold text-slate-900">
          Indian Public Offer Document Lifecycle &amp; Review Stages
        </h2>
      </div>
      <span className="px-2 py-0.5 rounded-md border border-slate-200 bg-slate-50 text-[10px] font-bold text-slate-600">SEBI ICDR Regulations, 2018</span>
    </div>
    <ol className="mt-4 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3">
      {LIFECYCLE_STAGES.map((stage) => (
        <li key={stage.stage} className="flex flex-col rounded-xl border border-slate-200 bg-slate-50/60 p-3.5">
          <div className="flex items-center justify-between gap-2">
            <span className="text-[10px] font-extrabold uppercase tracking-wider text-slate-400">{stage.stage}</span>
            <FileText className="w-3.5 h-3.5 text-slate-300" aria-hidden="true" />
          </div>
          <h3 className="mt-1 text-sm font-extrabold text-slate-900">{stage.title}</h3>
          <p className="mt-1 text-[11px] text-slate-500 leading-relaxed">{stage.body}</p>
          <p className="mt-auto pt-2.5 flex items-center justify-between gap-2 border-t border-slate-200/80 text-[11px]">
            <span className="text-slate-400">{stage.footLabel}:</span>
            <span className="font-bold text-slate-700 text-right">{stage.footValue}</span>
          </p>
        </li>
      ))}
    </ol>
  </section>
);

export default DrhpLifecycleGuide;
